import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components";


export const Wrap = styled.div`
  text-align: center;
  
  @media ${({theme}) => theme.device.phone}{
    margin-bottom: 24px;
  }
`;

export const WrapGrid = styled.div`
  ${props => props.state && css`
    grid-area: state;
  `};

  ${props => props.canva && css`
    position: relative;
    grid-area: canva;
  `};
`

export const PreviewImage = styled(GatsbyImage)`
  display: none;

  ${props => props.isvisible && css`
    display: block;
  `};
`;

export const SubMenuWrap = styled.div`
  display: inline-block;
  /* margin-top: 8px; */
`

export const SubMenuButton = styled.button`
  cursor: pointer;
  font-size: 13px;
  background: transparent;
  color: ${({theme}) => theme.primary.main};
  font-family: "Quantico", sans-serif;
  text-transform: uppercase;
  margin: 0 2px;
  padding: 8px;
  border: 1px solid transparent;

  svg{
    position: relative;
    top: 2px;
    fill: ${({theme}) => theme.primary.main};
    margin-right: 2px;
    margin-left: 2px;
  }

  &:hover{
    color: ${({theme}) => theme.primary.dark};
    svg{
      fill: ${({theme}) => theme.primary.dark};
    }
  }

  &:disabled, &:disabled:hover{
    cursor: default;
    color: ${({theme}) => theme.text.disabled};
    svg{
      fill: ${({theme}) => theme.text.disabled};
    }
  }
`;

export const SubMenuSep = styled.div`
  display: inline-block;
  height: 10px;
  margin: 0 4px 0 6px;
  border-right: 2px solid ${({theme}) => theme.secondary.main};
`;

export const ButtonActive = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &::before{
    content: ' ';
    position: absolute;
    right: 2px;
    top: 50%;
    width: 6px;
    height: 1px;
    /* margin-top: -1px; */
    background-color: #ffffff80;
  }

  &::after{
    content: ' ';
    left: 2px;
    position: absolute;
    top: 50%;
    width: 6px;
    height: 1px;
    /* margin-top: -1px; */
    background-color: #ffffff80;
  }
`;